import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import { Form, Input } from '@engloba-tech/englobity';
import { NAME_SPACE } from 'i18n';
import { isSkeletonLoading } from 'shared';
import { useReaderForm } from './useReaderForm';
import { useFormReaderStyles } from './formReader.styles';

export function FormReader({ formRef, onSubmit, reader, errors, onChangeInput }) {
  const { t } = useTranslation(NAME_SPACE.READERS);
  const classes = useFormReaderStyles();
  const { readerInputs, handleChange } = useReaderForm(reader, onChangeInput);

  function handleSubmit() {
    onSubmit(readerInputs);
  }

  return (
    <Form
      className={classes.formReader}
      errors={errors}
      elementRef={formRef}
      onSubmit={handleSubmit}
      autoComplete="off"
    >
      <Grid container spacing={3}>
        <Grid sm={12} md={6} item>
          <Input
            isLoading={isSkeletonLoading(readerInputs.name)}
            required
            name={t('properties.name')}
            label={t('properties.name')}
            variant="outlined"
            value={readerInputs.name || ''}
            onChange={handleChange('name')}
            inputProps={{ 'aria-label': t('properties.name') }}
            validators={['required', 'maxStringLength:255']}
            errorMessages={[t('validations.required'), t('common:validations.maxStringLength', { length: 255 })]}
          />
        </Grid>
        <Grid sm={12} md={6} item>
          <Input
            isLoading={isSkeletonLoading(readerInputs.ftpConfiguration)}
            required
            name={t('properties.ftpConfiguration')}
            label={t('properties.ftpConfiguration')}
            variant="outlined"
            value={readerInputs.ftpConfiguration || ''}
            multiline
            rows={5}
            onChange={handleChange('ftpConfiguration')}
            inputProps={{ 'aria-label': t('properties.ftpConfiguration') }}
            validators={['required', 'maxStringLength:512']}
            errorMessages={[t('validations.required'), t('common:validations.maxStringLength', { length: 512 })]}
          />
        </Grid>
      </Grid>
    </Form>
  );
}

FormReader.propTypes = {
  formRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  onSubmit: PropTypes.func,
  errors: PropTypes.shape({
    message: PropTypes.string,
    detail: PropTypes.string
  }),
  reader: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    ftpConfiguration: PropTypes.string
  }),
  onChangeInput: PropTypes.func
};
